module.exports = __webpack_public_path__ + "img/airplay-devices.1f49faa5.svg";